export const API_URL = "https://apimail.heimdallrwa.com/api/v1/mail";
